import React from 'react';
import imgImage7 from '../../assets/sections/dcc766cdc8825df76100188437074b17f14dd664.png';
import imgPolygon14 from '../../assets/sections/b60c0e2b218d8c0845e544b54a697b9196571cc6.png';
import imgUnion from '../../assets/sections/25e075afe4052321e6c950a3fafcc4849f3d61d1.svg';
import imgImage6 from '../../assets/sections/82b409f67c701b862ac668f193dacdbcc0d8d9e0.svg';
import imgGroup12 from '../../assets/sections/7d96929fc5288f473df650ae105c8804c46b57e2.svg';
import imgGroup16 from '../../assets/sections/52cb4ab48cd21c8925faa65471c7faf3a5f4b64d.svg';
import imgGroup17 from '../../assets/sections/4b092af9b6cfa5000fdd07da2ffe4c4499f08f44.svg';


export default function Timeline() {
  return (
    <div id="timeline" className="relative w-[1920px] h-[1080px]" data-node-id="180:164">
      <div className="absolute h-[1080px] left-0 top-0 w-[1921px]" data-name="Union" data-node-id="180:165">
        <img alt="" className="absolute block max-w-none size-full" src={imgUnion} />
      </div>
      <div className="absolute contents left-0 top-0" data-node-id="193:157">
        <div className="absolute h-[1127px] left-0 top-0 w-[1923px]" data-name="image 6" data-node-id="181:340"
          style={{ maskImage: `url('${imgImage6}')`, WebkitMaskImage: `url('${imgImage6}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '0px 0px', WebkitMaskPosition: '0px 0px', maskSize: '1923px 1080px', WebkitMaskSize: '1923px 1080px' }}>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img alt="" className="absolute h-[141.53%] left-[-0.99%] max-w-none top-[-39.13%] w-[103.69%]" src={imgImage7} />
          </div>
        </div>
      </div>
      <p className="absolute blur-[22px] font-['Alexandria',sans-serif] font-bold leading-[normal] left-[calc(50%-463px)] text-[70px] text-[rgba(233,255,250,0.5)] top-[135px] uppercase whitespace-nowrap" data-node-id="172:88">
        Timeline chương trình
      </p>
      <p className="absolute font-['Alexandria',sans-serif] font-bold leading-[normal] left-[calc(50%-463px)] text-[#e9fffa] text-[70px] top-[135px] uppercase whitespace-nowrap" data-node-id="190:87">
        Timeline chương trình
      </p>

      {/* Card 1: Nâng cấp 1000CV - left-[132] */}
      <div className="-translate-x-1/2 -translate-y-1/2 absolute h-[320px] left-[calc(50%-705px)] overflow-clip rounded-[16px] top-[calc(50%+97px)] w-[246px]" data-name="Background+Shadow" data-node-id="180:184">
        <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] text-[#d4f8eb] top-[32px] w-[205px]" data-node-id="186:25">
          <p className="font-['Alexandria',sans-serif] font-bold leading-[36px] relative shrink-0 text-[19px] text-shadow-[0px_7px_40px_rgba(255,255,255,0.55)] uppercase w-full" data-node-id="180:200">
            Nâng cấp 1000CV
          </p>
          <p className="font-['Alexandria',sans-serif] font-normal leading-[26px] relative shrink-0 text-[17px] w-full" data-node-id="180:201">
            Miễn phí cùng HR nhiều năm kinh nghiệm
          </p>
        </div>
        <div className="absolute h-[197px] left-[103px] top-[222px] w-[228px]" data-node-id="192:89">
          <img alt="" className="absolute block max-w-none size-full" height="197" src={imgPolygon14} width="228" />
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
      </div>

      {/* Card 2: Livestream tuyển dụng - left-[695] */}
      <div className="-translate-x-1/2 -translate-y-1/2 absolute h-[320px] left-[calc(50%-142px)] overflow-clip rounded-[16px] top-[calc(50%+97px)] w-[246px]" data-name="Background+Shadow" data-node-id="184:6">
        <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] text-[#d4f8eb] top-[32px] w-[205px]" data-node-id="186:32">
          <p className="font-['Alexandria',sans-serif] font-bold leading-[25px] relative shrink-0 text-[19px] text-shadow-[0px_7px_40px_rgba(255,255,255,0.65)] uppercase w-full" data-node-id="184:10">
            Livestream<br />tuyển dụng
          </p>
          <p className="font-['Alexandria',sans-serif] font-normal leading-[26px] relative shrink-0 text-[17px] w-full" data-node-id="184:11">
            Cùng đại diện từ MSB, WinCommerce và LG Innotek.
          </p>
        </div>
        <div className="absolute h-[197px] left-[103px] top-[222px] w-[228px]" data-node-id="192:93">
          <img alt="" className="absolute block max-w-none size-full" height="197" src={imgPolygon14} width="228" />
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
      </div>

      {/* Card 3: Kick-off Event - left-[976] */}
      <div className="-translate-x-1/2 -translate-y-1/2 absolute h-[320px] left-[calc(50%+139px)] overflow-clip rounded-[16px] top-[calc(50%+97px)] w-[246px]" data-name="Background+Shadow" data-node-id="183:363">
        <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] text-[#d4f8eb] top-[32px] w-[205px]" data-node-id="186:26">
          <p className="font-['Alexandria',sans-serif] font-bold leading-[36px] relative shrink-0 text-[19px] text-shadow-[0px_4px_70px_rgba(255,255,255,0.55)] uppercase w-full" data-node-id="183:364">
            Kick-off Event
          </p>
          <p className="font-['Alexandria',sans-serif] font-normal leading-[26px] relative shrink-0 text-[17px] w-full" data-node-id="183:365">
            Check-in nhận quà cực chất cùng TopCV tại Hải Phòng
          </p>
        </div>
        <div className="absolute h-[197px] left-[103px] top-[222px] w-[228px]" data-node-id="192:95">
          <img alt="" className="absolute block max-w-none size-full" height="197" src={imgPolygon14} width="228" />
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
      </div>

      {/* Card 4: Webinar - left-[413] */}
      <div className="-translate-x-1/2 -translate-y-1/2 absolute h-[320px] left-[calc(50%-424px)] overflow-clip rounded-[16px] top-[calc(50%+97px)] w-[246px]" data-name="Background+Shadow" data-node-id="184:9">
        <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] text-[#d4f8eb] top-[32px] w-[205px]" data-node-id="186:33">
          <p className="font-['Alexandria',sans-serif] font-bold leading-[25px] relative shrink-0 text-[19px] text-shadow-[0px_7px_40px_rgba(255,255,255,0.65)] uppercase w-full" data-node-id="184:10">
            Webinar<br />"Hải phòng - Xu hướng và cơ hội việc làm tương lai"
          </p>
          <p className="font-['Alexandria',sans-serif] font-normal leading-[26px] relative shrink-0 text-[17px] w-full" data-node-id="184:11">
            Cùng đại diện từ MSB, WinCommerce và LG Innotek.
          </p>
        </div>
        <div className="absolute h-[197px] left-[103px] top-[222px] w-[228px]" data-node-id="192:91">
          <img alt="" className="absolute block max-w-none size-full" height="197" src={imgPolygon14} width="228" />
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
      </div>

      {/* Card 5: Company tour - left-[1258] */}
      <div className="-translate-x-1/2 -translate-y-1/2 absolute h-[320px] left-[calc(50%+421px)] overflow-clip rounded-[16px] top-[calc(50%+97px)] w-[246px]" data-name="Background+Shadow" data-node-id="184:12">
        <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] text-[#d4f8eb] top-[32px] w-[205px]" data-node-id="186:35">
          <p className="font-['Alexandria',sans-serif] font-bold leading-[25px] relative shrink-0 text-[19px] text-shadow-[0px_4px_70px_rgba(255,255,255,0.8)] uppercase w-full" data-node-id="184:13">
            Company tour + Mock interview
          </p>
          <p className="font-['Alexandria',sans-serif] font-normal leading-[26px] relative shrink-0 text-[17px] w-full" data-node-id="184:14">
            Kết hợp doanh nghiệp, giúp ứng viên hình dung về môi trường làm việc tại Hải Phòng
          </p>
        </div>
        <div className="absolute h-[197px] left-[103px] top-[222px] w-[228px]" data-node-id="192:97">
          <img alt="" className="absolute block max-w-none size-full" height="197" src={imgPolygon14} width="228" />
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
      </div>

      {/* Card 6: Cuộc thi - left-[1539] */}
      <div className="-translate-x-1/2 -translate-y-1/2 absolute h-[320px] left-[calc(50%+702px)] overflow-clip rounded-[16px] top-[calc(50%+97px)] w-[246px]" data-name="Background+Shadow" data-node-id="184:15">
        <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] text-[#d4f8eb] top-[32px] w-[205px]" data-node-id="186:35">
          <p className="font-['Alexandria',sans-serif] font-bold leading-[25px] relative shrink-0 text-[19px] text-shadow-[0px_4px_70px_rgba(255,255,255,0.8)] uppercase w-full" data-node-id="184:13">
            Cuộc thi<br />"an cư quê nhà"
          </p>
          <p className="font-['Alexandria',sans-serif] font-normal leading-[26px] relative shrink-0 text-[17px] w-full" data-node-id="184:14">
            Kết hợp cùng WinCommverce tổ chức thi video về chủ đề “Bỏ phố về quê"
          </p>
        </div>
        <div className="absolute h-[197px] left-[103px] top-[222px] w-[228px]" data-node-id="192:99">
          <img alt="" className="absolute block max-w-none size-full" height="197" src={imgPolygon14} width="228" />
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
      </div>

      {/* Timeline line */}
      <div className="absolute h-[86px] left-[254.5px] top-[392px] w-[1408.5px]" data-node-id="188:81">
        <div className="absolute inset-[0_-1.14%_-18.6%_-1.14%]">
          <img alt="" className="block max-w-none size-full" src={imgGroup12} />
        </div>
      </div>
      <div className="absolute h-0 left-[136px] top-[392.5px] w-[1650px]" data-node-id="195:179">
        <div className="absolute inset-[-52.5px_-3.18%]">
          <img alt="" className="block max-w-none size-full" src={imgGroup16} />
        </div>
      </div>
      <div className="absolute h-0 left-[782px] top-[1010px] w-[356px]" data-node-id="195:180">
        <div className="absolute inset-[-48px_-13.48%]">
          <img alt="" className="block max-w-none size-full" src={imgGroup17} />
        </div>
      </div>

      {/* Dates */}
      <div className="absolute contents font-['Alexandria',sans-serif] font-normal leading-[26px] left-[177px] text-[#d4f8eb] text-[24px] top-[316px] uppercase whitespace-nowrap" data-node-id="188:80">
        <p className="absolute left-[177px] top-[316px]" data-node-id="188:49">20/03 - 15/04</p>
        <p className="-translate-x-1/2 absolute left-[537px] text-center top-[316px]" data-node-id="188:55">07/04</p>
        <p className="-translate-x-1/2 absolute left-[819px] text-center top-[316px]" data-node-id="188:57">09/04</p>
        <p className="-translate-x-1/2 absolute left-[1099.5px] text-center top-[316px]" data-node-id="188:59">10 - 12/04</p>
        <p className="-translate-x-1/2 absolute left-[1381px] text-center top-[316px]" data-node-id="188:60">11/04</p>
        <p className="-translate-x-1/2 absolute left-[1663px] text-center top-[316px]" data-node-id="188:61">15/04</p>
      </div>
    </div >
  );
}
